import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

export default function ConfirmDialog({ open, title, content, onClose, onConfirm }) {
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>{title || 'Confirm Action'}</DialogTitle>
        <DialogContent>
          <p>{content || 'Are you sure you want to proceed?'}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">Cancel</Button>
          <Button onClick={onConfirm} color="error" variant="contained">Confirm</Button>
        </DialogActions>
      </Dialog>
    );
  }